import script from "./Hue.vue?vue&type=script&setup=true&lang=js"
export * from "./Hue.vue?vue&type=script&setup=true&lang=js"

import "./Hue.vue?vue&type=style&index=0&id=641aaad0&lang=css"

const __exports__ = script;

export default __exports__